// src/CustomizePage.js
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import BackNavigation from "../../components/BackNavigation";
import Text from "../../components/Text";
import {
  CustomizeMainWrapper,
  Colors,
  ColorsWrapper,
  SideContainer,
  EmblemsList,
  EmblemsHeader,
  EmblemsWrapper,
  EmblemsContainer,
  ChosenEmblemContainer,
  ChosenEmblem,
} from "./Customize.style";
import Button from "../../components/Button";
import StartGameModal from "../../components/Modals/StartGameModal";
import {
  saveUserCustomization,
  fetchUserEmblem,
  getEmblemImagePath,
} from "../../API/emblem";
import NextBtn from "../../assets/next-btn-2.png";
import Emblem1 from "../../assets/emblem-1.png";
import Emblem2 from "../../assets/emblem-2.png";
import Emblem3 from "../../assets/emblem-3.png";
import Emblem4 from "../../assets/emblem-4.png";
import { Emblem } from "./Emblem";
import { ColorItem } from "./ColorItem";

const CustomizePage = ({
  selectedEmblem,
  setSelectedEmblem,
  selectedColor,
  setSelectedColor,
}) => {
  const navigate = useNavigate();
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    const userId = sessionStorage.getItem("user_id");
    const isGuest = sessionStorage.getItem("is_guest");
  
    if (!userId && !isGuest) {
      alert("User ID is missing. Redirecting to login...");
      navigate("/login");
    }
  }, [navigate]);
  
  const handleClick = (id) => {
    if (selectedEmblem === id) {
      setSelectedEmblem(null);
      console.log("Deselected emblem:", id);
    } else {
      setSelectedEmblem(id);
      console.log("Selected emblem:", id);
    }
  };
  

  const handleColorClick = (hexColor) => {
    const colorName = colorsArray[hexColor];
  
    // 🟡 If the clicked color is already selected, unselect it
    if (selectedColor === colorName) {
      setSelectedColor(null);
      console.log("Deselected color:", colorName);
    } else {
      setSelectedColor(colorName);
      console.log("Selected color updated:", colorName);
    }
  };
  

  const handleSaveCustomization = async () => {
    const userId = sessionStorage.getItem("user_id");
    const isGuest = sessionStorage.getItem("is_guest");
  
    if (!selectedEmblem || !selectedColor) {
      alert("Επιλέξτε και έμβλημα και χρώμα.");
      return;
    }
  
    if (isGuest) {
      // 🟡 Guest user — store only in sessionStorage
      sessionStorage.setItem("emblem_id", selectedEmblem);
      sessionStorage.setItem("color", selectedColor);
      sessionStorage.setItem(
        "emblem",
        getEmblemImagePath(selectedEmblem, selectedColor)
      );
  
      console.log("Guest customization saved in sessionStorage.");
      setIsOpen(true);
      return;
    }
  
    // 🟢 Logged-in user — save to DB
    const response = await saveUserCustomization(selectedEmblem, selectedColor);
    if (response.success) {
      setIsOpen(true);
    } else {
      alert("Failed to save customization.");
    }
  
    console.log("Saving customization with:", {
      user_id: userId,
      emblem_id: selectedEmblem,
      color: selectedColor,
    });
  };
  

  const colorsArray = {
    "#FFC14D": "yellow",
    "#CAED48": "lime",
    "#5CC45C": "green",
    "#52BDE2": "light_blue",
    "#5F70EE": "blue",
    "#B061FF": "purple",
    "#EC76AF": "pink",
    "#F13A6B": "red",
  };

  const emblems = [
    { id: "1", src: Emblem1 },
    { id: "2", src: Emblem2 },
    { id: "4", src: Emblem3 },
    { id: "3", src: Emblem4 },
  ];

  return (
    <CustomizeMainWrapper>
      <div style={{ height: "70px" }}>
  <BackNavigation mode="" url="/" />
</div>
      <EmblemsWrapper>
        <EmblemsList>
          <EmblemsHeader>
            <Text fontSize="40px" fontFamily="'Source Serif 4'" fontWeight="700">
              Εμβλήματα
            </Text>
            <Text fontSize="16px" fontFamily="Manrope" fontWeight="500">
              Επιλέξτε το έμβλημα που θες να αντιπροσωπεύεις
            </Text>
            <EmblemsContainer>
              {emblems.map(({ id, src }) => (
                <Emblem
                  key={id}
                  src={src}
                  selected={selectedEmblem === id}
                  onClick={() => handleClick(id)}
                />
              ))}
            </EmblemsContainer>
          </EmblemsHeader>
          <ColorsWrapper>
            <Text
              fontSize="30px"
              fontFamily="'Source Serif 4'"
              fontWeight="700"
              color="#F3DE8A"
            >
              Χρώμα
            </Text>
            <Text
              fontSize="16px"
              fontFamily="Manrope"
              fontWeight="500"
              color="#F3DE8A"
            >
              Επιλέξτε το αγαπημένο σου χρώμα
            </Text>
            <Colors>
              {Object.entries(colorsArray).map(([hex, name]) => (
                <ColorItem
                  key={hex}
                  bcolor={hex}
                  selected={selectedColor === name} // Compare using color name, not hex
                  onClick={() => handleColorClick(hex)} // Pass hex, but store name
                />
              ))}
            </Colors>
          </ColorsWrapper>
        </EmblemsList>
        <SideContainer selectedEmblem={selectedEmblem}>
          <Text fontSize="16px" fontWeight="500" color="#F3DE8A"
          fontFamily={"Manrope"}>
            Προεπισκόπηση
          </Text>
          <ChosenEmblemContainer>
  {selectedEmblem ? (
    <ChosenEmblem
      key={selectedColor} // 👈 This is the magic!
      src={
        selectedColor
          ? getEmblemImagePath(selectedEmblem, selectedColor)
          : emblems.find((e) => e.id === selectedEmblem)?.src
      }
      colored={!!selectedColor}
    />
  ) : null}
</ChosenEmblemContainer>


          <Button margin="175px 0 0 0"  imgurl={NextBtn} onClick={handleSaveCustomization} />
          <StartGameModal open={isOpen} onClose={() => setIsOpen(false)} />
        </SideContainer>
      </EmblemsWrapper>
    </CustomizeMainWrapper>
  );
};

export default CustomizePage;
